import React from 'react';
import * as adminApi from '../../../../api/adminApi';
import modalStyles from './AdminModals.module.css';

interface ViewAdminModalProps {
  isOpen: boolean;
  onClose: () => void;
  token: string | null;
  admin: adminApi.AdminSummary | null;
  formatAdminDate: (value?: string | null) => string;
  onEdit: () => void;
  onRevoke: () => void;
}

export const ViewAdminModal: React.FC<ViewAdminModalProps> = ({
  isOpen,
  onClose,
  token,
  admin,
  formatAdminDate,
  onEdit,
  onRevoke
}) => {
  if (!isOpen || !admin) return null;

  return (
    <div className={modalStyles.overlay} onClick={onClose}>
      <div className={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={modalStyles.header}>
          <h2 className={modalStyles.title}>Admin Profile</h2>
          <button onClick={onClose} className={modalStyles.closeBtn} aria-label="Close">✕</button>
        </div>

        <div className={modalStyles.body}>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.25rem', alignItems: 'center' }}>
            <div className={modalStyles.avatar}>{admin.full_name?.charAt(0).toUpperCase() || 'A'}</div>
            <div>
              <h3 style={{ margin: 0, fontSize: '1.05rem', fontWeight: 700, color: 'var(--admin-text,var(--ds-text))' }}>{admin.full_name}</h3>
              <p style={{ margin: '0.25rem 0 0', fontSize: '0.9rem', color: 'var(--admin-text-muted,var(--ds-text-muted))' }}>{admin.email}</p>
            </div>
          </div>

          <div className={modalStyles.grid2} style={{ marginBottom: '1rem' }}>
            <div className={modalStyles.statBox}>
              <p className={modalStyles.statLabel}>Status</p>
              <p className={modalStyles.statValue}><span style={{ color: admin.is_active ? 'var(--ds-success)' : 'var(--ds-danger)' }}>● {admin.is_active ? 'Active' : 'Inactive'}</span></p>
            </div>
            <div className={modalStyles.statBox}>
              <p className={modalStyles.statLabel}>Created</p>
              <p className={modalStyles.statValue}>{formatAdminDate(admin.created_at)}</p>
            </div>
          </div>
        </div>

        <div className={modalStyles.footer}>
          <div className={modalStyles.actions}>
            <button onClick={() => { onEdit(); onClose(); }} className={`${modalStyles.btn} ${modalStyles.primary}`}>Edit</button>
            <button onClick={() => { onRevoke(); onClose(); }} className={`${modalStyles.btn} ${modalStyles.danger}`}>Revoke Access</button>
            <button onClick={onClose} className={`${modalStyles.btn} ${modalStyles.neutral}`}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};
